import en from './en'
import cn from './cn'

export const Lang = {
    en,
    cn,

}
export const list = [{
        tit: 'English',
        val: 'en'
    },
    {
        tit: '简体中文',
        val: 'cn'
    },

]